const ANCHOR_SELECTOR = '[data-section-anchor]';

const normalizePath = (pathname) => pathname.replace(/\/+$/, '') || '/';

function getAnchorTarget(hash) {
  if (!hash || hash === '#') return null;

  let id;
  try {
    id = decodeURIComponent(hash.slice(1));
  } catch {
    return null;
  }

  const target = document.getElementById(id);
  return target?.matches(ANCHOR_SELECTOR) ? target : null;
}

function scrollToAnchor(target, behavior) {
  target.scrollIntoView({ behavior, block: 'start' });

  if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
  target.focus({ preventScroll: true });
}

const getScrollBehavior = () =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';

function closeMenuDrawers() {
  document.querySelectorAll('header-drawer').forEach((drawer) => {
    if (drawer instanceof HTMLElement && 'isOpen' in drawer && drawer.isOpen && 'close' in drawer) {
      drawer.close();
    }
  });
}

function onDocumentClick(event) {
  if (event.defaultPrevented || event.button !== 0) return;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  if (!(event.target instanceof Element)) return;

  const link = event.target.closest('a[href*="#"]');
  if (!(link instanceof HTMLAnchorElement)) return;
  if (link.target && link.target !== '_self') return;
  if (link.origin !== window.location.origin) return;
  if (normalizePath(link.pathname) !== normalizePath(window.location.pathname)) return;

  const target = getAnchorTarget(link.hash);
  if (!target) return;

  event.preventDefault();
  closeMenuDrawers();

  if (window.location.hash !== link.hash) {
    window.history.pushState(null, '', link.hash);
  }

  scrollToAnchor(target, getScrollBehavior());
}

function alignToHashOnLoad() {
  const target = getAnchorTarget(window.location.hash);
  if (!target) return;

  scrollToAnchor(target, 'instant');
}

document.addEventListener('click', onDocumentClick);

if (document.readyState === 'complete') {
  alignToHashOnLoad();
} else {
  window.addEventListener('load', alignToHashOnLoad, { once: true });
}
